import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1b0b5e54&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./../style.less?vue&type=style&index=0&id=1b0b5e54&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0b5e54",
  null
  
)

export default component.exports